import membership_type from './memberships/membership_type'
import membership_group from './memberships/membership_group'

import payment_type from './payment_details/payment_type'

import how_did_you_hear_about_us from './member_details/how_did_you_hear_about_us'

import title from './member_details/individual/title'

export const enums = {
    memberships: {
        membership_type  : membership_type,
        membership_group : membership_group
    },

    member_details: {
        how_did_you_hear_about_us : how_did_you_hear_about_us,
        individual                : {
            title     : title,
        }
    },

    payment_details: {
        payment_type: payment_type
    },
}